import { TableColumn } from '../../models/client/reports'

export const TABLE_COLUMNS_OPTIONS: TableColumn[] = [
  {
    label: 'Picture',
    value: 'assetImagePaths',
    type: 'general',
    sortable: false,
  },
  {
    label: 'Date',
    value: 'DATE',
    type: 'general',
    sortable: true,
  },
  {
    label: 'Time',
    value: 'TIME',
    type: 'general',
    sortable: true,
  },
  {
    label: 'Direction',
    value: 'assetDirection',
    type: 'general',
    sortable: true,
  },
  {
    label: 'Load type',
    value: 'loadType',
    type: 'load',
    sortable: true,
  },
  {
    label: 'Load number',
    value: 'loadNumber',
    type: 'load',
    sortable: true,
  },
  {
    label: 'Seal',
    value: 'hasSeal',
    type: 'load',
    sortable: false,
  },
  {
    label: 'Seal number',
    value: 'sealNumber',
    type: 'load',
    sortable: true,
  },
  {
    label: 'Load LP',
    value: 'loadLicensePlate',
    type: 'load',
    sortable: false,
  },
  {
    label: 'Load damage',
    value: 'loadDamage',
    type: 'load',
    sortable: false,
  },
  {
    label: 'Load dwell time',
    value: 'loadDwellTimeHr',
    type: 'load',
    sortable: false,
  },
  {
    label: 'Load remarks',
    value: 'loadRemarks',
    type: 'load',
    sortable: false,
  },
  {
    label: 'Chassis number',
    value: 'chassisNumber',
    type: 'chassis',
    sortable: false,
  },
  {
    label: 'Chassis LP',
    value: 'chassisLicensePlate',
    type: 'chassis',
    sortable: false,
  },
  {
    label: 'Chassis damage',
    value: 'chassisDamage',
    type: 'chassis',
    sortable: false,
  },
  {
    label: 'Chassis is bare',
    value: 'isBare',
    type: 'chassis',
    sortable: false,
  },
  {
    label: 'Chassis dwell time',
    value: 'chassisDwellTimeHr',
    type: 'chassis',
    sortable: false,
  },
  {
    label: 'Chassis remarks',
    value: 'chassisRemarks',
    type: 'chassis',
    sortable: false,
  },
  {
    label: 'Carrier',
    value: 'vehicleCarrierName',
    type: 'tractor',
    sortable: true,
  },
  {
    label: 'Truck number',
    value: 'vehicleNumber',
    type: 'tractor',
    sortable: false,
  },
  {
    label: 'Truck remarks',
    value: 'vehicleRemarks',
    type: 'tractor',
    sortable: false,
  },
  {
    label: 'Fuel type',
    value: 'vehicleFuelType',
    type: 'tractor',
    sortable: true,
  },
  {
    label: 'Truck DOT',
    value: 'vehicleDotNumber',
    type: 'tractor',
    sortable: false,
  },
  {
    label: 'Truck LP',
    value: 'vehicleLicensePlate',
    type: 'tractor',
    sortable: false,
  },
  {
    label: 'Truck damage',
    value: 'vehicleDamage',
    type: 'tractor',
    sortable: false,
  },
  {
    label: 'Truck class',
    value: 'vehicleWeightClass',
    type: 'tractor',
    sortable: true,
  },
]

export const DEFAULT_COLUMNS: TableColumn[] = [
  {
    label: 'Picture',
    value: 'assetImagePaths',
    type: 'general',
    sortable: false,
  },
  {
    label: 'Date',
    value: 'DATE',
    type: 'general',
    sortable: true,
  },
  {
    label: 'Time',
    value: 'TIME',
    type: 'general',
    sortable: true,
  },
  {
    label: 'Direction',
    value: 'assetDirection',
    type: 'general',
    sortable: true,
  },
  {
    label: 'Load type',
    value: 'loadType',
    type: 'load',
    sortable: true,
  },
  {
    label: 'Load number',
    value: 'loadNumber',
    type: 'load',
    sortable: true,
  },
  {
    label: 'Chassis number',
    value: 'chassisNumber',
    type: 'chassis',
    sortable: false,
  },
  {
    label: 'Chassis LP',
    value: 'chassisLicensePlate',
    type: 'chassis',
    sortable: false,
  },
  {
    label: 'Truck number',
    value: 'vehicleNumber',
    type: 'tractor',
    sortable: false,
  },
  {
    label: 'Truck LP',
    value: 'vehicleLicensePlate',
    type: 'tractor',
    sortable: false,
  },
]
